export const isClient = (typeof window !== 'undefined');

export const canUseDOM: boolean =
    isClient &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined';

export const isApple: boolean = canUseDOM && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
